import styled, { keyframes, css } from "styled-components";
import { darken } from "polished";
import { FiLoader } from "react-icons/fi";

const rotate = keyframes`
    to {
        transform: rotate(360deg);
    }
`;

interface IProps {
  action?: string;
  height?: string;
  fontSize?: string;
  fontWeight?: string;
}

export const Container = styled.div<IProps>`
  span {
    font-size: 15px;
    color: inherit;
  }
  button {
    border-radius: 46px;
    height: ${(props) => props.height || "auto"};
    min-height: ${(props) => props.height || "36px"};
    border: 0;
    padding: 9px 18px;
    color: #000;
    font-weight: ${(props) => props.fontWeight || 600};
    font-size: ${(props) => props.fontSize || "14px"};
    transition: all 0.3s ease;
    cursor: pointer;
    width: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;

    ${(props) =>
      props.action === "cancel"
        ? css`
            background-color: white;
            border: 2px solid ${props.theme.feedback.error};
            color: ${props.theme.feedback.error};
          `
        : props.action === "return"
        ? css`
            background-color: white;
            border: 2px solid ${props.theme.primary.original};
            color: ${props.theme.primary.original};
          `
        : props.action === "whatsapp"
        ? css`
            background-color: white;
            border: 2px solid ${darken(0.2, props.theme.feedback.success)};
            color: ${darken(0.2, props.theme.feedback.success)};
          `
        : props.action === "success"
        ? css`
            background-color: ${darken(0.08, props.theme.feedback.success_bg)};
            color: ${darken(0.3, props.theme.feedback.success)};
            border: 2px solid ${darken(0.3, props.theme.feedback.success)};

            :hover:enabled {
              background-color: ${darken(0.16, props.theme.feedback.success_bg)};
            }
          `
        : css`
            background: linear-gradient(135deg, #fcd177, #e7a73f);
            color: #000;
          `}

    :hover:enabled {
      ${(props) =>
        !props.action &&
        css`
          background: linear-gradient(135deg, #fdd98a, #ecb24e);
          color: #000;
        `}
    }

    :active:enabled {
      ${(props) =>
        !props.action &&
        css`
          background: linear-gradient(135deg, #e7a73f, #d39535);
          color: #000;
          box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.12);
        `}
    }

    :focus-visible:enabled {
      ${(props) =>
        !props.action &&
        css`
          box-shadow: 0 0 0 0.2rem rgba(218, 182, 134, 0.5);
        `}
    }

    :disabled {
      cursor: not-allowed;
      background: #d3a971;
      color: #fff;
      opacity: 0.65;
    }
  }
`;

export const Loader = styled(FiLoader)`
  margin-left: 10px;
  margin: 0 auto;
  font-size: 15px;
  vertical-align: middle;
  color: currentColor;
  animation: ${rotate} 2.5s infinite;
`;
